import { Component, type ErrorInfo, type ReactNode } from 'react';
import { ErrorPage } from '../error-page/error-page.component';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <ErrorPage/>
      );
    }

    return this.children;
  }

  private get children() {
    return this.props.children;
  }
}
